<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="100px" label-suffix="：" inline>
      
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" v-trim/>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input
          type="textarea"
          v-model="form.content"
          placeholder="请输入内容"
          :autosize="{ minRows: 4, maxRows: 12}"
          v-trim
        />
      </el-form-item>
      <el-form-item label="通知对象" prop="notifyObject">
        <el-radio-group v-model="form.notifyObject">
          <el-radio label="0">用户</el-radio>
          <el-radio label="1">商家</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
export default {
  name: 'OperaNoticeWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    let rule = (rule, value, callBack) => {
      debugger
      console.log(rule, value);
      callBack()
    }
    return {
      // 表单数据
      form: {
        id: null,
       
        title: '',
        content: '',
        notifyObject: '0',
        
      },
      // 验证规则
      rules: {
        title: [
          { required: true, message: '请输入标题', tigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', tigger: 'blur' }
        ],
        notifyObject: [
          { required: true,  message: '请输入选择通知对象', tigger: 'change' }
        ],
      }
    }
  },
  created () {
    this.config({
      api: '/business/notice',
      'field.id': 'id'
    })
  },
  methods: {
    // confirm() {
    //   console.log(this.form);
    // }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/alertstyle.scss';
</style>
